/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const MenuSmallChevronIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="MenuSmallChevronIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path d="M2 4H12V3H2V4Z" fill="currentColor" />
            <path d="M2 8H9V7H2V8Z" fill="currentColor" />
            <path d="M12 12H2V11H12V12Z" fill="currentColor" />
            <path
              d="M15.1465 6.14648L13 8.29293L10.8536 6.14648L10.1465 6.85359L13 9.70714L15.8536 6.85359L15.1465 6.14648Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

MenuSmallChevronIcon.tags = [
  'menu',
  'dropdown',
  'chevron',
  'navigation',
  'list',
];

MenuSmallChevronIcon.category = 'General Icons';

MenuSmallChevronIcon.iconSize = 16;
